module.exports = __webpack_public_path__ + "static/media/alerta-gps-verde.c49ebe22.svg";